module.exports = __webpack_public_path__ + "static/show-f565f1d8eb9f5f5466a4c65b26b7454c.png";